import DevLog from '../../devlog/Module'
import ViewportModule from '../../viewport/Module'
import errorAction from '../../../actions/error/errorAction'
import transferActionProps from '../transferActionProps'
import { doPost } from '../doPost'

import { IErrorResponse, IRequestExitActionBody } from '../types'
import { ModuleID } from '../../types'
import { IAction } from '../../../actions/types'

import { DEBUG_CLIENT } from '../const'
import { getProxyParamsFromUrl, getURLfromAction } from '../lib'

export default async function requestExitAction(fromAction: IAction) {
  const body: IRequestExitActionBody = {
    device: ViewportModule.viewport.device,
    mode: fromAction.mode,
    proxy_params: fromAction.action_proxy_params || getProxyParamsFromUrl(fromAction),
    payload: { name: 'exit' }
  }

  if (DEBUG_CLIENT) {
    DevLog._log(`SW[${ModuleID.CLIENT}]:`, 'requestExitAction', body)
  }

  let nextAction = errorAction({ ...fromAction })

  if (fromAction.action_url) {
    try {
      const response = await doPost<IAction | IErrorResponse>(getURLfromAction(fromAction), body).catch(error => {
        DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestExitAction')
        return errorAction({ ...fromAction })
      })
      nextAction =
        'error' === (response as IErrorResponse).status ? errorAction({ ...fromAction }) : (response as IAction)
      if (!nextAction.mode) {
        nextAction.mode = fromAction.mode
      }
    } catch (error) {
      DevLog.error(error, `SW[${ModuleID.CLIENT}]:`, 'requestExitAction')
    }
  } else {
    DevLog.error(new Error('no action_url in action'), `SW[${ModuleID.CLIENT}]:`, 'requestExitAction', fromAction)
  }

  return transferActionProps(fromAction, nextAction)
}
